if ('process' in globalThis) {
    globalThis.envs = {
        BASE_API_URL: globalThis.process.env['BASE_API_URL'],
        WEBDB_S3_URL: globalThis.process.env['WEBDB_S3_URL'],
        CONTENTDB_S3_URL: globalThis.process.env['CONTENTDB_S3_URL'],
    };
}
if ('Deno' in globalThis) {
    const env = Deno.env.toObject();
    globalThis.envs = {
        BASE_API_URL: env['BASE_API_URL'],
        WEBDB_S3_URL: env['WEBDB_S3_URL'],
        CONTENTDB_S3_URL: env['CONTENTDB_S3_URL'],
    };
}
globalThis.envs = globalThis.envs ?? {};
export const { OIDC_LOGIN, ROUTE_LOGOS_BASE_URL, POI_BASE_URL, GA_MEASUREMENT_ID, GRAPHHOPPER_URL, BASE_DATA_URL, BASE_API_URL, IMAGE_BASE_URL, CAPTCHA_SITEKEY, WEBDB_S3_URL, CONTENTDB_S3_URL, OIDC_ISSUER, OIDC_CLIENT_ID, VIADI_DEPARTURE_URL, VIADI_API_KEY, SCHWEIZMOBIL_PLUS_URL, SCHWEIZMOBIL_ACCOUNT_URL, SSE_URL, } = globalThis.envs;
//# sourceMappingURL=envs.js.map